// 账户及角色管理
import account from './account';
// 商品管理
import product from './product';

// 内容管理
import content from './content';

// 下载中心
import download from './download';

// 团队订单管理
import order from './order';

// 系统安全
import systemSafe from './systemSafe';

// 客户管理
import customerManage from './customerManage';

// 控销团队管理
import controlSalesTeamManage from './controlSalesTeamManage';

// 学术管理
import academicManage from './academicManage';

// 积分管理
import pointsManage from './pointsManage';

// 数据管理
import dataManage from './dataManage';

// 营销活动
import activity from './activity';

// 招商管理
import attractInvestment from './attractInvestment';

// 平台数据分析中心
import analysis from './analysis'
import assignment from './assignment'
import credit from './credit'
import separateAccount from './separateAccount';

export default [
  ...account,
  ...product,
  ...content,
  ...download,
  ...order,
  ...systemSafe,
  ...customerManage,
  ...controlSalesTeamManage,
  ...academicManage,
  ...pointsManage,
  ...dataManage,
  ...activity,
  ...attractInvestment,
  ...analysis,
  ...assignment,
  ...credit,
  ...separateAccount
];
